<script setup lang="ts">

import LearningStylesComplete from "@/components/Metrics/LearningStylesComplete.vue";
import HollandCodeComplete from "@/components/Metrics/HollandCodeComplete.vue";
import SubjectChoicesSelected from "@/components/Metrics/SubjectChoicesSelected.vue";
import RecentSignupsTile from "@/components/Metrics/RecentSignupsTile.vue";
import ValueScalesComplete from "@/components/Metrics/ValueScalesComplete.vue";
import ReportPeriodFilterBar from "@/components/Reporting/ReportPeriodFilterBar.vue";
import UsersSignedUp from "@/components/Metrics/UsersSignedUp.vue";
import Big5Completions from "@/components/Metrics/Big5Completions.vue";
import AccessCodesUsageRatioMetricTile from "@/components/Metrics/AccessCodesUsageRatioMetricTile.vue";
import {useReportingStore} from "@/store/reporting";
const reportingStore = useReportingStore();
</script>

<template>
  <ReportPeriodFilterBar
    :show-filters="true"
    :show-time-frame="false"
    @run-report="reportingStore.activateAndRefresh"
    @reset-filters="reportingStore.resetState"/>

  <v-row v-show="reportingStore.active">
    <v-col cols="9">
      <v-row>
        <v-col cols="3">
          <AccessCodesUsageRatioMetricTile/>
        </v-col>
        <v-col cols="3">
          <UsersSignedUp/>
        </v-col>
        <v-col cols="3">
          <HollandCodeComplete/>
        </v-col>
        <v-col cols="3">
          <Big5Completions/>
        </v-col>
        <v-col cols="3">
          <ValueScalesComplete/>
        </v-col>
        <v-col cols="3">
          <LearningStylesComplete/>
        </v-col>
        <v-col cols="3">
          <SubjectChoicesSelected/>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="3">
      <RecentSignupsTile/>
    </v-col>
  </v-row>
  <v-row v-if="!reportingStore.active">
    <v-col class="text-center text-gray mt-6">
      <h1>Please select a tenant, institution or cohort to see adoption metrics.</h1>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
